import Axios from 'axios'

export default function logout(): void {
  Axios.defaults.headers.common['Authorization'] = ''

  localStorage.removeItem('user')
  window.location.replace('/')
}
